import { Db } from 'mongodb'
import { schema, types } from 'papr'

export const postFollowCollectionName = 'postfollows'

export const postFollowSchema = schema(
	{
		user: types.objectId({ required: true }),
		post: types.objectId({ required: true }),
	},
	{
		timestamps: true,
	},
)

export const createPostFollowIndex = async (db: Db) => {
	await db.createIndex(postFollowCollectionName, {
		post: 1,
	})
}

export type PostFollowDocument = (typeof postFollowSchema)[0]
export type PostFollowSchemaOptions = (typeof postFollowSchema)[1]
